<template>
<div v-if="this.device != 'xs'">
  ©{{toDate(null,true,'YYYY')}} Todos os Direitos Reservados a <b>{{cliente.logged.nome}}</b>
</div>
</template>

<script>
	import Fct from 'common/fct'
	import Session from 'common/session'

  	export default {
		  mixins:[Fct,Session],
  		data () {
		   	return {
			}
		}
  	}
</script>


// WEBPACK FOOTER //
// footer.v2.vue?7289e382